var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"my-6 font-weight-regular"},[_vm._v("AVAILABLE STORES")]),_c('GroceryStoresGrid')],1)}
var staticRenderFns = []

export { render, staticRenderFns }